import { useContext, useState } from "react"
import getServices from "../services/getServices"
import { AuthContext } from "../contexts/auth"
import { use } from "react"


const useDashboardState = () => {

    const { signOut, atualizaPermissaoUsuario, user } = useContext(AuthContext)
    const [submit, setSubmit] = useState(false)
    const [permissaoUsuario, setPermissaoUsuario] = useState([])

    const _getPermissoes = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/permissaoatribuida/${user.value.id}/`)
        if (result.type === 'success'){
            const permissoesMapeadas = result.data.map(item => ([
                item.app_nome,
                item.funcionalidade_nome,
                item.tela,
                item.acao
                ]));
            setPermissaoUsuario(permissoesMapeadas);
            atualizaPermissaoUsuario(permissoesMapeadas);                    
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    return {
        submit: {value: submit, set: _getPermissoes},
        permissaoUsuario: {value: permissaoUsuario, set: setPermissaoUsuario},

    }
}

export default useDashboardState